import People from 'components/People'

export default People
